import React from "react";

function ListItemRow({listItem, removeListItem, disabled}) {
	return (

		<tr>
			<td>{listItem.value}</td>
			<td><button className={"btn btn-danger btn-sm"} disabled={disabled} type={"button"} onClick={(evt) => {
				removeListItem(listItem.id);
			}}>Remove</button></td>
		</tr>

	);
}

export default ListItemRow;
